import { darken } from 'polished';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { COLORS } from '../../styles/constants';

export const Container = styled.nav`
  width: 100%;
  height: 10vh;

  display: flex;

  background: ${COLORS.white};

  a {
    color: ${COLORS.darktext};
    text-decoration: none;
    transition: background-color 0.1s;
  }

  @media only screen and (min-width: 1400px) {
    height: 7vh;
  }

  @media only screen and (max-height: 450px) {
    display: none;
  }
`;

export const NavbarLeft = styled.div`
  width: 40%;

  display: flex;
  justify-content: flex-start;

  img {
    height: auto;
    width: 110px;
    image-rendering: -moz-crisp-edges; /* Firefox */
    image-rendering: -o-crisp-edges; /* Opera */
    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
  }
`;

export const NavbarRight = styled.div`
  width: 60%;

  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const NavbarLink = styled(Link)`
  height: 100%;
  padding: 0 15px !important;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: background-color 0.2s;

  cursor: pointer;

  &:hover {
    background: ${darken(0.04, COLORS.pinkwhite)};
  }

  h1 {
    margin: 0;
    font-size: 30px;
  }
`;

export const DropDownContainer = styled.div`
  position: relative;
  height: 100%;
`;

export const NavbarButton = styled.div`
  height: 100%;
  padding: 0 15px !important;

  display: flex;
  justify-content: center;
  align-items: center;

  border: none;
  background: none;
  transition: background-color 0.2s;

  cursor: pointer;

  &:hover {
    background: ${darken(0.04, COLORS.pinkwhite)};
  }
`;
